import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import _ from 'lodash';
import SettingsBackupRestoreOutlinedIcon from '@material-ui/icons/SettingsBackupRestoreOutlined';
import DoneOutlineOutlinedIcon from '@material-ui/icons/DoneOutlineOutlined';
import LiveHelpOutlinedIcon from '@material-ui/icons/LiveHelpOutlined';
import PropTypes from 'prop-types';

/**
 * 刪除使用的 dialog
 *
 * @param {*} props
 * {
 *   open [bool] 控制顯示
 *   setOpen [func] 設定 open 的函式
 *   action [func] 同意後執行的函式
 *   title [string] dialog 的標題
 *   children [jsx|string] dialog 的內容
 * }
 */
const AlertDialog = (props) => {
  const handleCloseDialog = () => {
    props.setOpen(false);
  };

  const handleAction = () => {
    if (_.isFunction(props.action)) {
      props.action();
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      {_.trim(props.title) != '' ? (
        <DialogTitle>
          <LiveHelpOutlinedIcon /> {props.title}
        </DialogTitle>
      ) : null}
      <DialogContent>
        <DialogContentText>{props.children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DoneOutlineOutlinedIcon />}
          onClick={handleAction}
          autoFocus>
          確認
        </Button>
        <Button
          onClick={handleCloseDialog}
          variant="contained"
          startIcon={<SettingsBackupRestoreOutlinedIcon />}>
          取消
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AlertDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  action: PropTypes.func,
  title: PropTypes.string,
};

export default AlertDialog;
